export default function (name, opts) {
  const widgetName = name;
  const widgetOpts = opts;

  const breakpoint = 1000;
  const isDesktopScreen = $(window).width() >= breakpoint;
  const wrapContainerClass = 'cards-container-wrapper';
  const $widget = $(`#${widgetName}`);
  let maxItemsVisible;

  if (widgetName === 'fairBigPromos') {
    maxItemsVisible = 2;
  } else if (widgetName === 'fairSmallPromos') {
    maxItemsVisible = 4;
  } else {
    maxItemsVisible = 3;
  }
  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isDesktopScreen ? [] : ['all'],
    showDescription: false,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    moreButton: true,
    maxItemsVisible: maxItemsVisible,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;

      if (widgetData.length <= 0) {
        $('body').addClass(`${widgetName}-no-data`);
        $(`#${widgetName}`).remove();
        if (widgetName === 'cardWidget') {
          $('.tier-two').remove();
        }
      } else {
        createCustomCards(widgetData);
        $('.tier-two').css('opacity', '1');
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];

      const $cardItem = $(this);
      $cardItem.find('.image-container').append('<div class="overlay"></div>');
      $cardItem.find('.card-content').remove();
      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
            <div class="hover-content">
              ${URL ? `<a href="${URL}" class="button">More</a>` : ''}
            </div>
          </div>`);

      $cardItem.removeAttr('target');

      if (!URL) {
        $cardItem.addClass('empty-card').removeAttr('href');
      } else {
        $cardItem.addClass('only-url');
      }
    });
  }
}
